import Glide from '@glidejs/glide';

function initializeGlide(sliderId, defaultPerView, leftArrowSelector, rightArrowSelector) {
    const glideElement = document.querySelector(sliderId);

    if (glideElement) {
        const glide = new Glide(glideElement, {
            type: "slider",
            perView: defaultPerView,
            rewind: false,
            bound: true,
            gap: 0,
            breakpoints: {
                800: { perView: 2 },
                480: { perView: 1 },
            },
        });

        const leftArrow = document.querySelector(leftArrowSelector);
        const rightArrow = document.querySelector(rightArrowSelector);

        // Check if arrows should be shown or hidden based on current viewport perView
        function updateArrowVisibility() {
            const totalSlides = glideElement.querySelectorAll('.glide__slide').length;
            const currentPerView = glide.settings.perView;

            // Show or hide arrows based on total slides and current perView
            if (totalSlides <= currentPerView) {
                if (leftArrow) leftArrow.style.display = 'none';
                if (rightArrow) rightArrow.style.display = 'none';
            } else {
                if (leftArrow) leftArrow.style.display = 'inline-block';
                if (rightArrow) rightArrow.style.display = 'inline-block';
            }
        }

        glide.on('mount.after', updateArrowVisibility);
        glide.on('resize', updateArrowVisibility); // Update visibility on window resize

        glide.mount();

        // Add event listeners for arrows
        if (leftArrow && rightArrow) {
            leftArrow.addEventListener('click', () => glide.go('<'));
            rightArrow.addEventListener('click', () => glide.go('>'));
        }
    }
}

// Initialize multiple sliders with specific perView values and arrow selectors
initializeGlide("#section-fourteen-slider", 4, ".section-fourteen-left-arrow", ".section-fourteen-right-arrow");
initializeGlide("#section-fortysix-slider", 4, ".section-fortysix-left-arrow", ".section-fortysix-right-arrow");
initializeGlide("#section-nineteen-slider", 3, ".section-nineteen-left-arrow", ".section-nineteen-right-arrow");
